import { useEffect, useState } from 'react';

import { router } from '@/lib/router/routes';

import { glacierAssistantApiAssistantConfig } from '@/lib/heyapi/sdk.gen';

import { ChatPanel } from './ChatPanel';
import { useChatStore } from './useChatStore';

async function fetchAssistantConfig(): Promise<boolean> {
  try {
    const { data } = await glacierAssistantApiAssistantConfig();
    return data?.enabled ?? false;
  } catch {
    return false;
  }
}

function pathIsAuthOnly(path: string): boolean {
  return path.startsWith('/auth/') || path.startsWith('/newgrad/');
}

export function ChatButton() {
  const { toggleOpen, isOpen } = useChatStore();
  const [isAuthPage, setIsAuthPage] = useState(() =>
    pathIsAuthOnly(window.location.pathname)
  );
  const [isEnabled, setIsEnabled] = useState(false);

  useEffect(() => {
    fetchAssistantConfig().then(setIsEnabled);
  }, []);

  useEffect(() => {
    setIsAuthPage(pathIsAuthOnly(router.state.location.pathname));
    return router.subscribe((state) => {
      setIsAuthPage(pathIsAuthOnly(state.location.pathname));
    });
  }, []);

  if (!isEnabled || isAuthPage) return null;

  return (
    <>
      <ChatPanel />
      <button
        onClick={toggleOpen}
        className="fixed bottom-20 right-6 z-50 flex h-14 items-center justify-center gap-2 rounded-full bg-emerald-700 px-4 text-white shadow-lg hover:bg-emerald-800"
        aria-label={isOpen ? 'Close AI Assistant' : 'Open AI Assistant'}
      >
        {isOpen ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
        ) : (
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
            </svg>
            <span className="text-sm font-semibold">AI</span>
          </>
        )}
      </button>
    </>
  );
}
